import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Ankeiler from '../sec_ankeiler/component';
import './styles/styles.scss';

class AnkeilerGrid extends Component {
  get isNumerical() {
    return this.props.numerical || false;
  }

  get pageSize() {
    return this.props.pageSize || 24;
  }

  get currentPage() {
    return this.props.currentPage || false;
  }

  get store() {
    return this.props.store;
  }

  get lastItemOverlay() {
    return this.props.lastItemOverlay;
  }

  /**
   * TODO: get url and link text from BE context
   * If url, show a link at the bottom of the list
   * @returns {node|null}
   */
  get linkComponent() {
    return null;
  }

  get variant() {
    const { variant, listType } = this.props;
    if (variant) {
      return variant;
    }
    return (listType === 'grid') ? 'medium' : listType;
  }

  get items() {
    const { items, products } = this.props;
    return items || products || [];
  }

  /*
   * Show product info on same page or not
   */
  get embeddedProductInfo() {
    if (this.variant === 'compact') {
      if (this.props.quickOrder) {
        return {
          quickOrder: this.props.quickOrder,
        };
      }
    }
    return false;
  }

  /**
   * create the badgeValue if needed
   */
  composeBadgeValue(i) {
    return this.isNumerical ? (i + 1) + (this.currentPage * this.pageSize) : null;
  }


  render() {
    const { fullWidth = true } = this.props;
    const lastItemIndex = this.items.length - 1;

    return (
      <div className={`ankeiler-grid ${fullWidth ? 'full' : ''}`} data-test-id="ankeilers-list">
        {this.items.map((elem, i) => {
          //In case we render the ankeiler grid on the stores page
          if (elem.storeId) {
            return (
              <div
                className={`column-${this.variant}`}
                key={`${i}-${elem.storeId}-${this.variant}`}
              >
                {(lastItemIndex === i) && this.lastItemOverlay}
                <div className={`grid-element-wrapper`}>
                  <Ankeiler
                    variant={this.variant}
                    xs={12} sm={12} md={12}
                    items={this.items}
                    position={i + 1}
                    index={i}
                    {...elem}
                  />
                </div>
              </div>
            )
          } else if (!(elem.text || (elem.price && Object.keys(elem.price).length > 0))) {
            return null;
          }
          return (
            <div
              className={`column-${this.variant}`}
              key={`${i}-${elem.url}-${this.variant}`}
            >
              {(lastItemIndex === i) && this.lastItemOverlay}
              <div className={`grid-element-wrapper`}>
                <Ankeiler
                  {...elem}
                  info={this.embeddedProductInfo}
                  variant={this.variant}
                  store={this.store}
                  xs={12} sm={12} md={12}
                  badgeValue={this.composeBadgeValue(i)}
                  position={i + 1}
                  index={i}
                  items={this.items}
                />
              </div>
            </div>);
        })}
        {this.linkComponent}
      </div>
    );
  }
}


AnkeilerGrid.propTypes = {
  /**
   * the store
   */
  store: PropTypes.object,
  /**
   * Ankeiler medium items to display inside grid
   *
   */
  variant: PropTypes.string,
  numerical: PropTypes.bool,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  items: PropTypes.array,
  products: PropTypes.array,
  /**
   * lastItemOverlay react element that can be used as a overlay item on the last item in the grid
   *
   */
  lastItemOverlay: PropTypes.element,
  layout: PropTypes.string,
  /*
   * quick order is passed down from the CMS.
   */
  quickOrder: PropTypes.bool,
  listType: PropTypes.oneOf(['list', 'grid', 'minimalList']),
  /**
   * If fullWidth is set to true, the filter is not show on desktop
   * and the ankleires should span over the entire width of container
   */
  fullWidth: PropTypes.bool,
};


export default AnkeilerGrid;

